import { Component, OnDestroy } from '@angular/core';
import { Platform, ToastController, MenuController, AlertController, ActionSheetController, App, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { provider } from '../providers/provider';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { LocalNotifications, ILocalNotification } from '@ionic-native/local-notifications';
import { CustomizerProvider } from '../providers/customizer/customizer';
import { AppVersion } from '@ionic-native/app-version';
import { Globalization } from '@ionic-native/globalization';
import { Subject } from 'rxjs';
import { CustomerRegistrationPage } from '../pages/account/customerRegistration/customerRegistration';
import { CustomerEditPage } from '../pages/account/customerEdit/customerEdit';
import { AddressesPage } from '../pages/account/addresses/addresses';
import { CustomerCardPage } from '../pages/account/customercard/customercard';
import { CustomerPage } from '../pages/account/customer/customer';
import { AboutPage } from '../pages/about/about';
import { Search } from '../pages/search/search';
import { CouponPage } from '../pages/coupon/coupon';
import { MenuPage } from '../pages/menu/menu';
import { HomePage } from '../pages/home/home';

declare let window: any;

@Component({
  templateUrl: 'app.html'
})
export class smarTavolinux implements OnDestroy {
  private notificationCount = 1;
  rootPage = HomePage;
  version: String;
  private _onDestroy = new Subject();
  customerInfo = {};
  prepaidcard: boolean;
  coupon: boolean;

  constructor(
    public provider: provider,
    public platform: Platform,
    public toastCtrl: ToastController,
    public statusBar: StatusBar,
    public translateService: TranslateService,
    public splashScreen: SplashScreen,
    public alertCtrl: AlertController,
    public storage: Storage,
    public localNotifications: LocalNotifications,
    public customizer: CustomizerProvider,
    public appVersion: AppVersion,
    private globalization: Globalization,
    public actionSheetCtrl: ActionSheetController,
    public menuCtrl: MenuController,
    public app: App,
    public loadingCtrl: LoadingController
  ) {
    storage.set('versione', platform.versions());
    this.getCustomer();
    translateService.addLangs(['it', 'en', 'fr', 'es', 'de','nl']);
    translateService.setDefaultLang(customizer.getDefaultLanguage());
    translateService.use(customizer.getDefaultLanguage());

    platform.ready().then(() => {
      splashScreen.show();

      this.globalization.getPreferredLanguage().then(res => {
        let value = res.value;
        console.log("Language: " + value)
        let lang = ['it', 'en', 'fr', 'es', 'de','nl'];

        lang.filter((item) => {
          if ((value).toLowerCase().startsWith(item)) {
            translateService.setDefaultLang(item);
            translateService.use(item);
          }
        })
      }).catch(e => {
        translateService.setDefaultLang(customizer.getDefaultLanguage());
        translateService.use(customizer.getDefaultLanguage());
      });

      // blocco tasto indietro
      //platform.registerBackButtonAction(() => console.log('non puoi tornare indietro'));

      this.appVersion.getVersionNumber().then(version => {
        this.version = version;
      }).catch(error => {
        this.version = 'browser';
      });

      this.appVersion.getPackageName().then(packageName => {
        console.log('Package name: ' + packageName);
      }).catch(error => {
        console.log(error)
      });

      statusBar.styleDefault();
      splashScreen.hide();

    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getCustomer() {
    this.prepaidcard = this.provider.getPrepaidCard();
    this.coupon = this.provider.getCoupon();
    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });
  }

  openMenu() {
    this.getCustomer();
    this.menuCtrl.open();
  }

  closeMenu() {
    this.getCustomer();
    this.menuCtrl.close();
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  GOTOhomepage() {
    // if cart is not empty, ask user
    const cart = this.provider.getCart();
    if (cart.length > 0) {
      this.translateService.get(['ATTENZIONE', 'CART_IS_NOT_EMPTY', 'PROCEED', 'ANNULLA']).takeUntil(this._onDestroy).subscribe(msg => {
        const prompt = this.alertCtrl.create({
          title: msg.ATTENZIONE,
          message: msg.CART_IS_NOT_EMPTY,
          buttons: [
            { text: msg.ANNULLA },
            {
              text: msg.PROCEED,
              handler: result => {
                this.provider.setSelectedLocale(false);
                this.provider.clearApp();
                location.reload();
                this.app.getActiveNav().push(HomePage);
              }
            }
          ]
        });
        prompt.present();
      });
    } else {
      // go back to home
      this.provider.setSelectedLocale(false);
      this.provider.clearApp();
      location.reload();    
      this.app.getActiveNav().push(HomePage);
    }
  }

  GOTOcoupons() {
    this.app.getActiveNav().push(CouponPage);
  }

  GOTOedit() {
    //this.provider.deleteCart();
    this.app.getActiveNav().push(CustomerEditPage);
  }

  GOTOregistration() {
    this.app.getActiveNav().push(CustomerRegistrationPage);
  }

  GOTOlogin() {
    this.app.getActiveNav().push(CustomerPage);
  }

  GOTOaddresses() {
    this.app.getActiveNav().push(AddressesPage);
  }

  GOTOcards() {
    this.prepaidcard = this.provider.getPrepaidCard();
    if(this.prepaidcard)
      this.app.getActiveNav().push(CustomerCardPage);
    else {
      let toast = this.toastCtrl.create({
        message: "Per questo esercizio non è disponibile il servizio di Carta fedeltà",
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    }

  }

  GOTOinfoLocale() {
    this.app.getActiveNav().push(AboutPage);
  }

  logout() {
    //this.storage.remove('customer');
    this.storage.clear();
    this.provider.deleteCart();
    this.getCustomer();
    this.app.getActiveNav().push(MenuPage);
  }

  translate() {
    let lang = ['it','en', 'fr', 'es', 'de','nl'];

    this.translateService.get('LANGUAGE').takeUntil(this._onDestroy).subscribe(obj => {
      let buttons = obj.languages.map((language, index) => ({
        text: language, handler: () => { this.storage.set('language', lang[index]); this.translateService.use(lang[index]); }
      }))
      let actionSheet = this.actionSheetCtrl.create({
        title: obj.label,
        buttons
      });
      actionSheet.present();
    }, err => console.log(err));
  };

  //! buildLocalNotification created a local notification object to be used in many context
  buildLocalNotification(notification): ILocalNotification {
    var notificationId = this.notificationCount++;
    var notificationObj: ILocalNotification = {
      id: notificationId,
      badge: notificationId, // brutta, lo
      title: 'TAP Menu',
      text: '',
      led: '',
      sound: null,
      foreground: true,
    };
    if (notification.action === 'RESCHEDULED') {
      var date = new Date(notification.args);
      notificationObj.text = 'Ciao, c\'è molto lavoro e l\'esercente ha dovuto spostare il tuo ordine alle ' + date.getHours()+':'+date.getMinutes() + '.'; //.toLocaleTimeString('it-IT')
      notificationObj.led = '00ff6501'; // orange
    } else if (notification.action === 'VOIDED') {
      notificationObj.text = 'Siamo spiacenti, ma il tuo ordine è stato annullato. Contatta l\'esercente per chiarimenti.';
      notificationObj.led = '00ff0000'; // red
    } else if (notification.action === 'CONFIRMED') {
      notificationObj.text = 'Perfetto ! Il tuo ordine è stato gestito dall\'esercente. A breve !'
      notificationObj.led = '0000ff00'; // green
    }
    return notificationObj;
  }

  //! showLocalNotification shows the local notification popup
  showLocalNotification(notification: ILocalNotification) {
    this.localNotifications.schedule(notification);
  }

  //! showLocalNotification schedules a mobile notification message with led
  showNotificationPopup(notification: ILocalNotification) {
    let message = '';
    if (Array.isArray(notification.text)) {
      message = notification.text[0];
    } else {
      message = notification.text;
    }
    const alert = this.alertCtrl.create({
      title: notification.title,
      message: message,
      buttons: [
        { text: 'OK', role: 'cancel' }
      ]
    });
    alert.present();
  }

  showInvalidUserPopup() {
    console.log('Invalid user in local storage !');
    this.storage.remove('customer').then(() => {
      const alert = this.alertCtrl.create({
        title: 'Utente cancellato',
        message: 'L\'utente corrente è stato cancellato dal database centrale.',
        buttons: [
          { text: 'OK', role: 'cancel' }
        ]
      });
      alert.present();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts